import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../styles'

const PrimaryButton = ({
  onClick,
  children,
  disabled,
  style,
  size, // 👈 nova prop opcional
  ...rest
}) => {
  // se size vier, aplica width/height padrão quadrado
  const sizeStyle = size
    ? {
      width: size, height: size, minWidth: size, minHeight: size
    }
    : {}

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      style={{ ...sizeStyle, ...style }} // 👈 size tem prioridade mas pode ser sobrescrito em style
      {...rest}
    >
      {children}
    </Button>
  )
}

PrimaryButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]).isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.shape({}),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 👈 novo
}

PrimaryButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  style: null,
  size: null, // 👈 padrão sem tamanho fixo
}

export default PrimaryButton
